module.exports = __webpack_public_path__ + "static/3-min-ca7eecd4bf4fe1d204ede2c5653522f6.jpeg";